export default "__VITE_ASSET__BXNOB7L7__"